module.exports = __webpack_public_path__ + "img/qrcode-icon.f6b96e82.png";